import React from 'react';

import AppHeader from '../../components/AppHeader';

// Material components
import {
    Grid,
} from '@material-ui/core';
// Styles
import images from '../../assets/images/images'
import { fonts } from '../../assets/jss';

function About() {

    return (
        <AppHeader>
            <h2 style={fonts.secondary}>About</h2>
            <Grid container>
                <Grid item sx={4}>
                    <img src={images[0].src} alt="earthfest" width='500' />
                </Grid>
                <Grid item sx={4}>
                    <img src={images[1].src} alt="earthfest" width='500' />
                </Grid>
                <Grid item sx={4}>
                    <img src={images[2].src} alt="earthfest" width='500' />
                </Grid>
            </Grid>
        </AppHeader>
    );
}

export default About;